import {
  QuoteCommentModel,
  QuoteContractModel,
  QuotePriceModel,
  QuotePriceModelPatch,
  QuotesModel,
  ReEvaluateQuoteRequestModel
} from '../../api/Argentia/endpoints/quotes/model/quotes'
import {
  apiDeactivateQuote,
  apiDeleteQuote,
  apiDeleteQuoteContract,
  apiGetContractQuotes,
  apiGetLeadQuotes,
  apiGetAllLeadQuotes,
  apiGetQuote,
  apiGetQuoteComments,
  apiGetQuotes,
  apiGetQuotesPriceList,
  apiPatchQuote,
  apiPatchQuoteContract,
  apiPatchQuotePriceList,
  apiPostQuoteComment,
  apiPostQuoteContract,
  apiPublishQuote,
  apiPublishQuoteMassive,
  apiReEvaluateQuote
} from '../../api/Argentia/endpoints/quotes/quotes.api'
import { EnumEstadoOferta } from '../../api/oData/enums/enumEstadoOferta'
import { EnumTipoLead } from '../../api/oData/enums/enumTipoLead'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'

export const fetchQuotes = async (
  productId?: number,
  tollType?: number
): Promise<ServiceResponse<QuotesModel | undefined>> => {
  return await apiGetQuotes(productId, tollType)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchQuote = async (
  leadId: number
): Promise<ServiceResponse<QuotesModel | undefined>> => {
  return await apiGetQuote(leadId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchLeadQuotes = async (
  leadId: number,
  leadType?: EnumTipoLead
): Promise<ServiceResponse<QuotesModel[] | undefined>> => {
  return await apiGetLeadQuotes(leadId, leadType)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchAllLeadQuotes = async (
  leadId: number,
  leadType?: EnumTipoLead
): Promise<ServiceResponse<QuotesModel[] | undefined>> => {
  return await apiGetAllLeadQuotes(leadId, leadType)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchContractQuotes = async (
  contractId: number
): Promise<ServiceResponse<QuotesModel[] | undefined>> => {
  return await apiGetContractQuotes(contractId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateQuote = async (
  leadId: number,
  request: QuotesModel
): Promise<ServiceResponse<QuotesModel | undefined>> => {
  return await apiPatchQuote(leadId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const publishQuoteAsync = async (
  quoteId: number
): Promise<ServiceResponse<any | undefined>> => {
  return await apiPublishQuote(quoteId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const publishQuoteMassiveAsync = async (
  leadIds: number[]
): Promise<ServiceResponse<number[] | undefined>> => {
  return await apiPublishQuoteMassive(leadIds)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// PriceList
export const fetchQuotePriceList = async (
  quoteId: number
): Promise<ServiceResponse<QuotePriceModel[] | undefined>> => {
  return await apiGetQuotesPriceList(quoteId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateQuotePriceList = async (
  quoteId: number,
  priceComponentId: number,
  request: QuotePriceModelPatch
): Promise<ServiceResponse<QuotePriceModel | undefined>> => {
  return await apiPatchQuotePriceList(quoteId, priceComponentId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deactivateQuote = async (
  quoteId: number,
  state: EnumEstadoOferta
): Promise<ServiceResponse<boolean | undefined>> => {
  return await apiDeactivateQuote(quoteId, state)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteQuote = async (
  quoteId: number
): Promise<ServiceResponse<boolean | undefined>> => {
  return await apiDeleteQuote(quoteId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const reEvaluateQuote = async (
  request: ReEvaluateQuoteRequestModel
): Promise<ServiceResponse<any | undefined>> => {
  return await apiReEvaluateQuote(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// QuoteComments

export const fetchQuoteComments = async (
  quoteId: number
): Promise<ServiceResponse<QuoteCommentModel[] | undefined>> => {
  return await apiGetQuoteComments(quoteId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createQuoteComment = async (
  quoteId: number,
  request: QuoteCommentModel
): Promise<ServiceResponse<QuoteCommentModel | undefined>> => {
  return await apiPostQuoteComment(quoteId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// QuoteContracts

export const createQuoteContract = async (
  quoteId: number,
  request: QuoteContractModel
): Promise<ServiceResponse<QuoteContractModel | undefined>> => {
  return await apiPostQuoteContract(quoteId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateQuoteContract = async (
  quoteId: number,
  quoteContractId: number,
  request: QuoteContractModel
): Promise<ServiceResponse<QuoteContractModel | undefined>> => {
  return await apiPatchQuoteContract(quoteId, quoteContractId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteQuoteContract = async (
  quoteId: number,
  quoteContractId: number
): Promise<ServiceResponse<object | undefined>> => {
  return await apiDeleteQuoteContract(quoteId, quoteContractId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
